import { useQuery } from "@apollo/client";
import { OrganizationProjectsDocument } from "../../../../__generated__/graphql";

export default function useOrganizationProjects() {
  const { data, loading, error, refetch } = useQuery(
    OrganizationProjectsDocument
  );

  return { data, loading, error, refetch };
}
